import { render, staticRenderFns } from "./ThirtyTwoTable.vue?vue&type=template&id=9f4c9ec4&"
import script from "./ThirtyTwoTable.vue?vue&type=script&lang=js&"
export * from "./ThirtyTwoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports